import { Observable } from 'rxjs';
import { ISecret } from './notebook-secret-types';

export abstract class NotebookSecretFacade {
  abstract secrets$: Observable<ISecret[]>;
  abstract secretKeys$: Observable<string[]>;
  abstract isSecretsExist$: Observable<boolean>;
  abstract notebookToken$: Observable<string>;
  abstract notebookSession$: Observable<any>;
  abstract loadSecrets(): void;
}
